webpackJsonp([4],{

/***/ 181:
/***/ (function(module, exports) {

module.exports = {"ronda-1":"Round 1","ronda-2":"Round 2","ronda-3":"Round 3","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.39e7215a67d056741343.js